/* tslint:disable */
/* eslint-disable */
/**
 * Commerce List App Service
 * This is to provide all the list related operations at data tier.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: shikha.raghava@amway.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ListType = {
    Wishlist: 'WISHLIST',
    Shareable: 'SHAREABLE',
    Private: 'PRIVATE'
} as const;
export type ListType = typeof ListType[keyof typeof ListType];


export function ListTypeFromJSON(json: any): ListType {
    return ListTypeFromJSONTyped(json, false);
}

export function ListTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListType {
    return json as ListType;
}

export function ListTypeToJSON(value?: ListType | null): any {
    return value as any;
}

